import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  // var reg = /^newtb.*/;
  // var Token = ''; 
  // if(reg.test(location.host)){
  //   Token = 'Admin-Token2'
  // }else{
  // }
  let Token = TokenKey
  var Tokens = Cookies.get(Token);
  return Tokens
}
export function setToken(token) {
  return Cookies.set(TokenKey, token, {
    // domain: '580tequan.com',
    path: "/",
    expires: 1
  })
}
export function removeToken() {
  // var reg = /^newtb.*/;
  // var Token = ''; 
  // if(reg.test(location.host)){
  //   Cookies.remove(TokenKey,{
  //     domain: '580tequan.com',
  //     path:"/"
  //   })
  //   Token = 'Admin-Token2';
  //   return Cookies.remove(Token,{
  //     domain: '580tequan.com',
  //     path:"/"
  //   })
  // }else{
  //   Token = TokenKey;
  //   Cookies.remove('Admin-Token2',{
  //     domain: '580tequan.com',
  //     path:"/"
  //   })
  //   return Cookies.remove(Token)
  // }  
  let Token = TokenKey;
  return Cookies.remove(Token)
}

export function getCookies(name) {
  return Cookies.get(name)
}
export function setCookies(name, value) {
  return Cookies.set(name, value, {
    expires: 1
  })
}
export function removeCookies(name) {
  return Cookies.remove(name)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js